import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { DefaultIndexPage, IndexPages } from '@/constant';

export function useGNBTabs() {
  const router = useRouter();
  const tabs = useMemo(() => {
    return [
      {
        label: 'HOME',
        value: IndexPages.HOME,
        selectedPath: [/^\/app\/f-talk/],
      },
      {
        label: 'WORK',
        value: IndexPages.WORK,
        // 캘린더(PORTAL-12626)는 /calendar 라우트지만 WORK 소속이다 —
        // 여기 등록해야 GNB 가 WORK 를 선택 상태로 그린다
        selectedPath: [/^\/work/, /^\/approval\/viewer/, /^\/calendar/],
      },
      {
        label: 'SOCIAL',
        value: IndexPages.SOCIAL,
        selectedPath: [/^\/board/],
      },
    ];
  }, []);

  const activeTabIndex = tabs.findIndex(
    ({ value }) =>
      value ===
      ((router.query.tab as string) ?? DefaultIndexPage).toLowerCase(),
  );
  const activeTab = tabs[activeTabIndex];

  return {
    tabs,
    defaultTab: DefaultIndexPage,
    activeTab: activeTab,
  };
}
